import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { request } from "../../../../../api/Service";
import { store } from "../../../../../redux-store/store";
import { useForm, Form } from "../../../../controls/useForm";
import Controls from "../../../../controls/Controls";

const initialFValues = {
  id: 0,
  truckType: "",
  truckName: "",
  truckDescription: "",
  isOnlineStore: false,
  dateCreated: new Date(),
};

export default function AddTruckType(props) {
  const { addLocation, recordForEdit, locationTypes } = props;
  const [states, setState] = useState([]);
  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    if ("truckType" in fieldValues)
      temp.truckType = fieldValues.truckType ? "" : "This field is required.";
    if ("truckName" in fieldValues)
      temp.truckName = fieldValues.truckName ? "" : "This field is required.";
    if ("truckDescription" in fieldValues)
      temp.truckDescription = fieldValues.truckDescription
        ? ""
        : "This field is required.";
    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");

    console.log("your Values🎌🎌", values);
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });

    validate({ [name]: value });
    request("get", {}, `api/Admin/get-states-dropdown/${value}`).then(
      (data) => {
        setState(data);
      }
    );
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      var result = {
        ...values,
        companyId: store.getState().persistReducer.companyId,
      };
      addLocation(result, resetForm);
    }
  };

  useEffect(() => {
    if (recordForEdit !== null)
      setValues({
        ...recordForEdit,
      });
  }, [recordForEdit]);

  const onlineStore = [
    { title: "True", id: true },
    { title: "False", id: false },
  ];

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={6}>
          <Controls.Input
            label="Truck Type ID*"
            name="truckType"
            value={values.truckType || ""}
            onChange={handleInputChange}
            error={errors.locationName}
          />
        </Grid>
        <Grid item xs={6}>
          <Controls.Input
            label="Truck Name*"
            name="truckName"
            value={values.truckName || ""}
            onChange={handleInputChange}
            error={errors.locationDescription}
          />
        </Grid>
        <Controls.Inputs
          label="Truck Description*"
          name="truckDescription"
          value={values.truckDescription || ""}
          onChange={handleInputChange}
          error={errors.locationAddress}
        />
      </Grid>
      <Controls.Button type="submit" text="Submit" />
    </Form>
  );
}
